import React from 'react'
import Layout from '../components/Layout'
import styled from 'styled-components'
import Seo from '../components/SEO/PageSeo'

const Legal = () => {
  return (
    <Layout>
      <Seo />
      <Wrapper>
        <h1>Legal Information</h1>
        <h2>Author</h2>
        Jay Fischer
        <br />
        Lipper Weg 121
        <br />
        45772 Marl
        <br />
        Germany
        <h3>Email</h3>
        kontakt@inkfs.com
        <br />
        <h3>Phone</h3>
        00 49 178 8 137 148
        <h2>General notice and mandatory information</h2>
        <h3>Designation of the responsible entity</h3>
        The entity responsible for data processing on this website is: Ink and
        Feather Design Studios Jay Fischer Lipper Weg 121 45772 Marl Germany The
        responsible body decides alone or jointly with others about the purposes
        and means of the processing of personal data (e.g. names, contact
        details or similar).
        <h3>Revocation of your consent to data processing</h3>
        Some data processing operations are only possible with your express
        consent. A revocation of your already given consent is possible at any
        time. An informal communication by e-mail is sufficient for the
        revocation. The legality of the data processing carried out until the
        revocation remains unaffected by the revocation.
        <h3>Right to complain to the competent supervisory authority</h3>
        As a data subject, you have the right to complain to the competent
        supervisory authority in the event of a data protection violation. The
        competent supervisory authority with regard to data protection issues is
        the state data protection commissioner of the federal state in which our
        company's registered office is located. The following link provides a
        list of data protection officers and their contact details:
        https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html.
        <h3>Right to data portability</h3>
        You have the right to have data that we process automatically on the
        basis of your consent or in fulfillment of a contract handed over to you
        or to third parties. The data will be provided in a machine-readable
        format. If you request the direct transfer of the data to another
        responsible party, this will only be done insofar as it is technically
        feasible.
        <h3>Right to information, correction, blocking, deletion</h3>
        Within the framework of the applicable legal provisions, you have the
        right at any time to free information about your stored personal data,
        the origin of the data, their recipients and the purpose of the data
        processing and, if applicable, a right to correction, blocking or
        deletion of this data. In this regard, and also for further questions on
        the subject of personal data, you can contact us at any time via the
        contact options listed in the imprint.
        <h3>SSL or TLS encryption</h3>
        For security reasons and to protect the transmission of confidential
        content that you send to us as site operator, our website uses SSL or
        TLS encryption. This means that data you transmit via this website
        cannot be read by third parties. You can recognize an encrypted
        connection by the "https://" address line of your browser and the lock
        symbol in the browser line.
        <h3>Server log files</h3>
        In server log files, the provider of the website automatically collects
        and stores information that your browser automatically transmits to us.
        These are:
        <ul>
          <li>Visited page on our domain</li>
          <li>Date and time of the server request</li>
          <li>Browser type and browser version</li>
          <li>Operating system used</li>
          <li>Referrer URL</li>
          <li>Host name of the accessing computer</li>
          <li>IP address</li>
        </ul>
        There is no merging of this data with other data sources. The data
        processing is based on Art. 6 (1) lit. b DSGVO, which permits the
        processing of data for the fulfillment of a contract or pre-contractual
        measures.
        <h3>Contact form and Newsletter registration</h3>
        Data transmitted via contact form will be stored, including your contact
        data, in order to be able to process your inquiry or to be available for
        follow-up questions. This data will not be passed on without your
        consent. The processing of the data entered in the contact form is based
        exclusively on your consent (Art. 6 para. 1 lit. a DSGVO). A revocation
        of your already given consent is possible at any time. An informal
        communication by e-mail is sufficient for the revocation. The legality
        of the data processing operations carried out until the revocation
        remains unaffected by the revocation. Data transmitted via the contact
        form or via registration for the newsletter will remain with us until
        you request us to delete it, revoke your consent to store it or there is
        no longer any need to store the data. Mandatory legal provisions - in
        particular retention periods - remain unaffected.
        <br />
        <br />
        Source: Data protection configurator from
        mein-datenschutzbeauftragter.de
      </Wrapper>
    </Layout>
  )
}

export default Legal

const Wrapper = styled.section`
  width: 85vw;
  max-width: 1100px;
  margin: 0 auto;
  margin-top: 5rem;
  margin-bottom: 4rem;
  h1,
  h2,
  h3,
  h4 {
    margin-top: 2rem;
  }
  ul {
    margin: 1rem;
  }
`
